export default function TransactionSplitApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getTransactionSplits(transactionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/transactionSplit?bankTransactionId=${transactionId}`));
        });
    }

    function updateTransactionSplit(transactionID, split) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/transactionSplit/${transactionID}`, split));
        });
    }

    function deleteTransactionSplit(transactionID) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/transactionSplit?transactionSplitId=${transactionID}`));
        });
    }

    function getBankTransactions(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/transactionSplit/centre?centreId=${centreId}`));
        });
    }

    function matchTransactionToSplit(centreTransactionId, bankTransactionId, transactionSplitId) {
        const payload = {
            centreTransactionId,
            bankTransactionId
        };
        
        // Only include transactionSplitId if it's provided (for split drops)
        if (transactionSplitId !== null && transactionSplitId !== undefined) {
            payload.transactionSplitId = transactionSplitId;
        }
        
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/transactionsplit/centre`, payload));
        });
    }

    function unlinkTransactionFromSplit(centreId, splitId) {

        const payload = {
            centreId,
            transactionSplitId: splitId
        }

        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/transactionsplit/unlink`, payload ));
        });
    }

    return {
        getTransactionSplits,
        updateTransactionSplit,
        deleteTransactionSplit,
        getBankTransactions,
        matchTransactionToSplit,
        unlinkTransactionFromSplit
    }

}